<template>
    <el-row :gutter="30"  class="mw-100 manage-field" >
        
        <el-col :lg="24" :xs="24">
            
            <el-card>
                <el-form
                    class="text-center font-24" 
                    ref="addParentFieldRef"
                    :model="currentFieldData"
                    :rules="currentFieldDataRules"
                    label-position="top"
                >
                    <el-row :gutter="30">
                        <el-col :lg="24" :xs="24">
                            <el-form-item>
                                <el-button type="primary" @click="manageField('addFieldRef')" class="text-cap">
                                    <font-awesome-icon :icon="['fas', 'floppy-disk']" style="width:20px" class="mr-10" />
                                    save
                                </el-button>
                            </el-form-item>
                        </el-col>
                        
                    </el-row>
                </el-form>
                <el-tabs  tab-position="left">
                    <el-tab-pane  v-for="(item, index) in currentFieldData.translates" :key="index" >
                        <template #label>
                            <span class="custom-tabs-label">
                                <span>
                                    {{$getLanguageName(item.languageID)}}
                                </span>
                            </span>
                        </template>
                        <el-form 
                            class="text-center font-24" 
                            ref="addFieldRef"
                            :model="currentFieldData"
                            :rules="currentFieldDataRules"
                            label-position="top"
                        >
                            <el-row :gutter="30">
                               
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="title" :prop="`translates[${index}].title`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentFieldData.translates[index].title"></el-input>    
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :xs="24">
                                    <el-form-item  label="description" :prop="`translates[${index}].description`" :class="$getLanguageName(item.languageID).toLowerCase() == 'عربي' ? 'text-right':''">
                                        <el-input type="text" v-model="currentFieldData.translates[index].description"></el-input>    
                                    </el-form-item>
                                </el-col>
                                
                                
                            </el-row>
                        </el-form>
                    </el-tab-pane>
                </el-tabs>
            </el-card>
        </el-col>
    </el-row>
    
</template>

<script>
export default {
    data(){
        return {
            isAddField:true,
            currentField:[],
            fileList:[],
            dialogVisible:false,
            dialogImageUrl:'',
            fileUploaded:false,

            currentFieldData:{},
            currentFieldDataRules:{
                value:{
                    required:true,
                    message:'required field',
                    trigger:'blur',
                },
                translates:this.$setTranslateRules(['title']),
            }
        };
    },
    computed:{
        cachedField(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.contactUs?.contactUsFields.currentContactUsField || {}
        }
    },
    mounted(){
        if (this.$route.params.id && this.$route.params.id == this.cachedField.id) {
            this.isAddField = false;
            this.currentFieldData = JSON.parse(JSON.stringify(this.cachedField))
            this.currentFieldData.translates = this.$filterPublishedTranslates(this.currentFieldData.translates)
        }else{
            this.$router.push({
                name:'contact-manage-field',
            })
            this.currentFieldDataRules.imageBase64 = [
                {
                    required:true,
                    trigger:'blur',
                    message:'required field'

                }
            ]
            this.isAddField = true;
            this.currentFieldData = this.initState()
        }
    },
    
    methods:{
        initState(){
            return {
                
                translates:this.$setTranslateKeys({
                    'title':'',
                    'description':'',
                })
            }
        },
       
        async manageField(formName){
            let successForm = [];
            for (let index = 0; index < this.$refs[formName].length; index++) {
                const element = this.$refs[formName][index];
                element.validate(async (valid) => {
                    if (!valid) {
                        this.$message({
                            message:`please fill the data in the ${this.$getOrderName(index + 1)} tab `,
                            type:'info',
                            duration:5000,
                            showClose: true,
                        });
                    }
                }).then(data =>{
                    let indexOfIndex = successForm.indexOf(index);
                    if (data){
                        successForm.push(index);
                        if (successForm.length == this.$refs['addFieldRef'].length){
                            this.manageFieldAfterValidate()
                        }
                    }else{
                        if(indexOfIndex != -1) {
                            successForm.splice(indexOfIndex,1);
                        }
                    }
                })  
            }
           
            
            
            
            
            
        },
        async manageFieldAfterValidate(){
            
            const response = await this.$store.dispatch(this.isAddField ? 'addField':'updateContactUsFields',this.currentFieldData);
            if (response.data.status == 1) {
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                });
                await this.$store.dispatch('getContactUsFields');
                this.$router.push({
                    name:'contact-fields-list'
                })
            }
        },
      
    }
}
</script>
<style lang="scss">
    .manage-field {
        .ck-editor {
            width:100%;
        }
    }
</style>